import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Thankyou from "../components/Thankyou";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function ThankyouPage(){
    const location = useLocation();
    const navigate = useNavigate();
    const { message } = location.state || { message: "Server Error. Please try again later." };

    useEffect(() => {
        setTimeout(() => {
            navigate('/');
        },4500);
    }, []);

    return (
        <div className="flex flex-col min-h-screen">
            <Navbar/>
            <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24 my-10 mt-5">
                <Thankyou message={message}/>
            </div>
            <Footer/>
        </div>
    )
}

export default ThankyouPage;